var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 7.75V11.5C15.25 11.5663 15.2236 11.6299 15.1768 11.6768C15.1299 11.7236 15.0663 11.75 15 11.75H13.7324C13.6953 11.4926 13.6007 11.2453 13.4551 11.0273C13.2628 10.7397 12.9896 10.5152 12.6699 10.3828C12.3502 10.2504 11.9977 10.2157 11.6582 10.2832C11.3188 10.3508 11.0074 10.518 10.7627 10.7627C10.518 11.0074 10.3508 11.3189 10.2832 11.6582C10.2772 11.6886 10.273 11.7195 10.2686 11.75H6.73242C6.69528 11.4926 6.60072 11.2453 6.45508 11.0273C6.26281 10.7397 5.98957 10.5152 5.66992 10.3828C5.35015 10.2504 4.99767 10.2157 4.6582 10.2832C4.31885 10.3508 4.00737 10.518 3.7627 10.7627C3.51802 11.0074 3.35076 11.3188 3.2832 11.6582C3.27717 11.6886 3.27296 11.7195 3.26855 11.75H2C1.9337 11.75 1.87013 11.7236 1.82324 11.6768C1.77636 11.6299 1.75 11.5663 1.75 11.5V9.25H11.75V7.75H15.25Z",
    fill: "#F90808",
    stroke: "#F90808",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/Truck.1cd4319121cc187ffbc4401eb89c56c8.svg";
export { ForwardRef as ReactComponent };